// The kept setup-entries answers (see setupEntriesAccess.ts) in a module of their
// own with no imports: the tenants and auth stores clear it, and must not pull the
// module API clients in through setupPanel.ts (an import cycle with utils/api).
export type SetupAnswers = Record<string, string[]>;

export const setupCache = {
  answers: new Map<string, SetupAnswers>(),
  inflight: new Map<string, Promise<SetupAnswers>>(),
  generation: 0,
};

/** Drop every kept answer: sign-out, tenant switch, a membership re-read. */
export function forgetSetupEntries(): void {
  setupCache.generation += 1;
  setupCache.answers.clear();
  setupCache.inflight.clear();
}
